import { createReducer } from "reduxsauce";
import Types from "./types";
import { getUnderscoreToCamelcaseText } from "../../../utils/helpers/get-underscore-to-camelcase-text";
// import  pollingConfig from "./poll-config.json";

const RATIG_AND_REVIEWS_DEFAULT_INITIALSTATE = {
    happyCustomers: { count: "10,000+" },
    ratingAndReviews: {
        google: { rating: 4.6, reviews: "1000+" },
        trustPilot: { rating: 4.5, reviews: "300+" },
        productReview: { rating: 4.5, reviews: "600+" }
    }
};
export const INITIAL_STATE = {
    cityList: [],
    map: "googlemap",
    drivaPollingConfig: null,
    isGetDrivaPollingConfigError: null,
    drivaPollingConfigLoading: false,
    inHouseFinancePollingConfig: null,
    isGetInHouseFinancePollingConfigError: null,
    inHouseFinancePollingConfigLoading: false,
    checkoutText: {
        deliveryScreen: {
            deliveryFAQ: [],
            homeDeliveryInformation: [],
            pickUpInformation: [],
            disclaimer: [],
            voucherHeading: ""
        },
        orderSummaryScreen: {}
    },
    clpCrmVariantConfig: null,
    ratingsConfig: {
        ...RATIG_AND_REVIEWS_DEFAULT_INITIALSTATE
    },
    saleConfig: {
        isSSR: false,
        data: {},
        isLoading: false,
        error: false
    },
    hubLocations: null,
    checkout_deposit_config: null,
    configs: {},
    testDriveCmsConfig: {
        data: null,
        isLoading: false,
        error: null
    },
    checkinWorkflow: null
};

export const fetchCityListSuccess = (state = INITIAL_STATE, { cityList }) => {
    return { ...state, cityList };
};

export const getDrivaTimeoutConfigRequest = (state = INITIAL_STATE, { loading }) => {
    return {
        ...state,
        drivaPollingConfigLoading: loading,
        isGetDrivaPollingConfigError: null
    };
};

export const getDrivaTimeoutConfigSuccess = (state = INITIAL_STATE, { data = {} }) => {
    return {
        ...state,
        drivaPollingConfig: data,
        drivaPollingConfigLoading: false,
        isGetDrivaPollingConfigError: null
    };
};

export const getDrivaTimeoutConfigFailure = (state = INITIAL_STATE, { error }) => {
    return {
        ...state,
        drivaPollingConfigLoading: false,
        isGetDrivaPollingConfigError: error
    };
};

export const getInHouseFinanceTimeoutConfigRequest = (state = INITIAL_STATE, { loading }) => {
    return {
        ...state,
        inHouseFinancePollingConfigLoading: loading,
        isGetInHouseFinancePollingConfigError: null
    };
};

export const getInHouseFinanceTimeoutConfigSuccess = (state = INITIAL_STATE, { data = {} }) => {
    return {
        ...state,
        inHouseFinancePollingConfig: data,
        inHouseFinancePollingConfigLoading: false,
        isGetInHouseFinancePollingConfigError: null
    };
};

export const getInHouseFinanceTimeoutConfigFailure = (state = INITIAL_STATE, { error }) => {
    return {
        ...state,
        inHouseFinancePollingConfigLoading: false,
        isGetInHouseFinancePollingConfigError: error
    };
};

const drivaPollApiSuccess = (state = INITIAL_STATE) => {
    return {
        ...state
    };
};

const drivaPollApiFailure = (state = INITIAL_STATE) => {
    return {
        ...state
    };
};

export const fetchConfigInit = (state = INITIAL_STATE) => {
    return {
        ...state
    };
};

export const fetchConfigSuccess = (state = INITIAL_STATE, { data = {} }) => {
    return {
        ...state,
        saleConfig: { ...state.saleConfig,
            isLoading: false,
            data,
            error: false }

    };
};

export const setHubLocationsData = (state = INITIAL_STATE, { data = {} }) => {
    return {
        ...state,
        hubLocations: data

    };
};

export const setCrmVariantConfig = (state = INITIAL_STATE, { data = {} }) => {
    return {
        ...state,
        clpCrmVariantConfig: data
    };
};

export const fetchConfigWithTypeInit = (state = INITIAL_STATE) => {
    return {
        ...state,
        configs: {
            ...state.configs,
            isLoading: true,
            error: false
        }
    };
};

export const fetchConfigWithTypeSuccess = (state = INITIAL_STATE, { data: configData = [] }) => {
    const newConfigs = { ...(state.configs || {}) };
    (configData?.data || []).forEach(item => {
        const camelCaseConfigType = getUnderscoreToCamelcaseText(item?.config?.configType);
        newConfigs[camelCaseConfigType] = {
            ...newConfigs[camelCaseConfigType],
            ...item?.config
        };
    });
    return {
        ...state,
        configs: {
            ...newConfigs,
            isLoading: false,
            error: false
        }
    };
};

export const fetchConfigWithTypeFailure = (state = INITIAL_STATE, { error }) => {
    return {
        ...state,
        configs: {
            ...state.configs,
            isLoading: false,
            error
        }
    };
};

const getLoanAppToggleConfigRequest = (state = INITIAL_STATE, { loading }) => {
    return {
        ...state,
        loanAppToggleConfigLoading: loading,
        isGetLoanAppToggleConfigError: null
    };
};

const getLoanAppToggleConfigSuccess = (state = INITIAL_STATE, { data = {} }) => {
    return {
        ...state,
        loanAppToggleConfig: data
    };
};

const getLoanAppToggleConfigFailure = (state = INITIAL_STATE, { error }) => {
    return {
        ...state,
        loanAppToggleConfigLoading: false,
        isGetLoanAppToggleConfigError: error
    };
};

export const fetchTestDriveCmsConfigInit = (state = INITIAL_STATE) => {
    return {
        ...state,
        testDriveCmsConfig: {
            ...(state.testDriveCmsConfig || {}),
            isLoading: true,
            error: null
        }
    };
};
export const fetchCheckinWorkflowInit = (state = INITIAL_STATE) => {
    return {
        ...state,
        checkinWorkflow: {
            ...(state.checkinWorkflow || {}),
            isLoading: true,
            error: false
        }
    };
};

export const fetchTestDriveCmsConfigSuccess = (state = INITIAL_STATE, { data = {} }) => {
    return {
        ...state,
        testDriveCmsConfig: {
            data,
            isLoading: false,
            error: null
        }
    };
};
export const fetchCheckinWorkflowSuccess = (state = INITIAL_STATE, { data = {} }) => {
    return {
        ...state,
        checkinWorkflow: {
            isLoading: false,
            error: false,
            data
        }
    };
};

export const fetchTestDriveCmsConfigFailure = (state = INITIAL_STATE, { error }) => {
    return {
        ...state,
        testDriveCmsConfig: {
            ...(state.testDriveCmsConfig || {}),
            isLoading: false,
            error
        }
    };
};
export const fetchCheckinWorkflowFailure = (state = INITIAL_STATE, { error }) => {
    return {
        ...state,
        checkinWorkflow: {
            ...(state.checkinWorkflow || {}),
            isLoading: false,
            error
        }
    };
};

export const HANDLERS = {
    [Types.FETCH_CITY_LIST_SUCCESS]: fetchCityListSuccess,
    [Types.GET_DRIVA_TIMEOUT_CONFIG_SUCCESS]: getDrivaTimeoutConfigSuccess,
    [Types.GET_DRIVA_TIMEOUT_CONFIG_FAILURE]: getDrivaTimeoutConfigFailure,
    [Types.GET_DRIVA_TIMEOUT_CONFIG_REQUEST]: getDrivaTimeoutConfigRequest,
    [Types.GET_IN_HOUSE_FINANCE_TIMEOUT_CONFIG_SUCCESS]: getInHouseFinanceTimeoutConfigSuccess,
    [Types.GET_IN_HOUSE_FINANCE_TIMEOUT_CONFIG_FAILURE]: getInHouseFinanceTimeoutConfigFailure,
    [Types.GET_IN_HOUSE_FINANCE_TIMEOUT_CONFIG_REQUEST]: getInHouseFinanceTimeoutConfigRequest,
    [Types.DRIVA_API_POLL_SUCCESS]: drivaPollApiSuccess,
    [Types.DRIVA_API_POLL_FAILURE]: drivaPollApiFailure,
    [Types.FETCH_CONFIG_INIT]: fetchConfigInit,
    [Types.FETCH_CONFIG_SUCCESS]: fetchConfigSuccess,
    [Types.LOAN_APP_TOGGLE_CONFIG_REQUEST]: getLoanAppToggleConfigRequest,
    [Types.LOAN_APP_TOGGLE_CONFIG_SUCCESS]: getLoanAppToggleConfigSuccess,
    [Types.LOAN_APP_TOGGLE_CONFIG_FAILURE]: getLoanAppToggleConfigFailure,
    [Types.FETCH_CONFIG_WITH_TYPE_SUCCESS]: fetchConfigWithTypeSuccess,
    [Types.FETCH_CONFIG_WITH_TYPE_FAILURE]: fetchConfigWithTypeFailure,
    [Types.FETCH_CONFIG_WITH_TYPE_INIT]: fetchConfigWithTypeInit,
    [Types.FETCH_TEST_DRIVE_CMS_CONFIG_INIT]: fetchTestDriveCmsConfigInit,
    [Types.FETCH_TEST_DRIVE_CMS_CONFIG_SUCCESS]: fetchTestDriveCmsConfigSuccess,
    [Types.FETCH_TEST_DRIVE_CMS_CONFIG_FAILURE]: fetchTestDriveCmsConfigFailure,
    [Types.FETCH_CHECKIN_WORKFLOW_INIT]: fetchCheckinWorkflowInit,
    [Types.FETCH_CHECKIN_WORKFLOW_SUCCESS]: fetchCheckinWorkflowSuccess,
    [Types.FETCH_CHECKIN_WORKFLOW_FAILURE]: fetchCheckinWorkflowFailure
};

export default createReducer(INITIAL_STATE, HANDLERS);
